import React from "react";

import './Button.switch.scss';

function ButtonSwitch({ label, bool, onChange }) {
    const handleChange = () => {
        onChange(!bool);
    }
    return (
        <div className="buttonSwitchComponent">
            <label>
                <input checked={bool} type="checkbox" onChange={handleChange}/>
                <span className="slider">
                </span>
            </label>
            {
               bool?  <h4>{label}</h4> : <span>{label}</span>
            }
        </div>
    )
}

export default ButtonSwitch;